import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

// Components
import BrandingFooter from '~/components/general/branding/branding-footer';

const Footer = props => {
	const currentYear = new Date().getFullYear();

	return (
		<Wrapper id="page-footer">
			<div className="l__row">
				<div className="grid-x grid-margin-x footer-wrapper">
					<div id="footer-left" className="cell small-12 medium-6 large-3 branding-and-copyright">
						<figure className="branding-small">
							<BrandingFooter />
						</figure>
						<p className="copyright">&copy; {`Copyright ${currentYear} Run4aChild ™`}</p>
						<a
							title="Check out our Website"
							href="https://www.wit-software.com/"
							target="_blank"
							rel="noopener noreferrer"
							className="powered-by"
						>
							Powered by WIT Software
						</a>
					</div>
					<div id="footer-right">
						<p className="social-description">
							Follow us on Social Media to know more about the stories behind the challenges, the goals and the
							donations.
						</p>
						<ul className="cell small-12 medium-6 large-3 social">
							<li id="email" className="icon">
								<a title="Send us an email" href="mailto:run4achild@wit-software.com">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										data-name="Layer 1"
										viewBox="0 0 48 48"
										aria-labelledby="title-social-email"
									>
										<title id="title-social-email">Send us an email</title>
										<path
											fill="#fff"
											fillRule="evenodd"
											d="M6.32 11l15.13 12a3.9 3.9 0 0 0 2.55.74 3.9 3.9 0 0 0 2.55-.74l15.13-12c1.21-1 .93-1.74-.6-1.74H6.93c-1.54 0-1.82.78-.61 1.74"
										/>
										<path
											fill="#fff"
											fillRule="evenodd"
											d="M42.77 14.2L26.24 26.75a3.71 3.71 0 0 1-2.24.68 3.66 3.66 0 0 1-2.23-.68L5.23 14.2C4 13.27 3 13.77 3 15.31V35.9a2.81 2.81 0 0 0 2.8 2.8h36.4a2.81 2.81 0 0 0 2.8-2.8V15.31c0-1.54-1-2-2.23-1.11"
										/>
									</svg>
								</a>
							</li>
							<li id="instagram" className="icon">
								<a
									title="Follow us on Instagram"
									href="https://www.instagram.com/run4achild/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										data-name="Layer 1"
										viewBox="0 0 48 48"
										aria-labelledby="title-social-instagram"
									>
										<title id="title-social-instagram">Follow us on Instagram</title>
										<path
											fill="#fff"
											d="M44.41 15.34a15.72 15.72 0 0 0-1-5.1 11.05 11.05 0 0 0-.89-1.83 10.86 10.86 0 0 0-3.13-3.27 9.84 9.84 0 0 0-2-1 14.76 14.76 0 0 0-5-1C30.27 3 29.58 3 24 3s-6.27 0-8.46.13a14.76 14.76 0 0 0-5 1 10.11 10.11 0 0 0-3.62 2.39 10.2 10.2 0 0 0-2.37 3.72 15.48 15.48 0 0 0-.95 5.1c-.11 2.24-.13 3-.13 8.66s0 6.42.13 8.66a15.75 15.75 0 0 0 .95 5.1 10.33 10.33 0 0 0 2.37 3.72 10.11 10.11 0 0 0 3.63 2.42 14.76 14.76 0 0 0 5 1c2.18.1 2.88.1 8.45.1s6.27 0 8.46-.13a14.76 14.76 0 0 0 5-1 10.64 10.64 0 0 0 6-6.14 15.72 15.72 0 0 0 1-5.1c.1-2.24.12-3 .12-8.66s-.07-6.39-.17-8.63zm-3.7 17.15a11.87 11.87 0 0 1-.71 3.9 6.73 6.73 0 0 1-.32.73 7 7 0 0 1-2.68 2.8 5.92 5.92 0 0 1-.91.45 11 11 0 0 1-3.81.72c-2.17.11-2.82.13-8.3.13s-6.13 0-8.3-.13a11 11 0 0 1-3.81-.72 6.63 6.63 0 0 1-.93-.45 6.74 6.74 0 0 1-1.41-1.12 6.67 6.67 0 0 1-1.21-1.67 6.88 6.88 0 0 1-.32-.74 11.87 11.87 0 0 1-.71-3.9c-.1-2.22-.12-2.88-.12-8.49s0-6.27.12-8.49a11.87 11.87 0 0 1 .71-3.9 6.88 6.88 0 0 1 .32-.74A6.67 6.67 0 0 1 9.53 9.2 6.74 6.74 0 0 1 11 8.08a6.63 6.63 0 0 1 .93-.45 11 11 0 0 1 3.81-.72c2.17-.1 2.82-.13 8.3-.13h3.36c2.55 0 3.32 0 4.94.12a11 11 0 0 1 3.81.72 6.63 6.63 0 0 1 .93.45 6.74 6.74 0 0 1 1.39 1.13 6.67 6.67 0 0 1 1.21 1.67 6.88 6.88 0 0 1 .32.74 11.87 11.87 0 0 1 .71 3.9c.07 1.63.1 2.42.11 4.93V24c.01 5.61-.01 6.27-.11 8.49z"
										/>
										<path
											fill="#fff"
											d="M33.94 20.44a10.65 10.65 0 0 0-6.58-6.65 10.13 10.13 0 0 0-3.36-.57A10.66 10.66 0 0 0 13.46 24a10.54 10.54 0 1 0 21.08 0 11 11 0 0 0-.6-3.56zM24 31a7 7 0 0 1 0-14 6.63 6.63 0 0 1 3.36.91 6.9 6.9 0 0 1 2.53 2.53 7.14 7.14 0 0 1 .95 3.56A6.92 6.92 0 0 1 24 31zM35 15.31a2.52 2.52 0 1 0-2.47-2.52A2.49 2.49 0 0 0 35 15.31z"
										/>
									</svg>
								</a>
							</li>
							<li id="discord" className="icon">
								<a
									title="Check out our Discord Channel"
									href="https://discord.gg/vHZucXgznM"
									target="_blank"
									rel="noopener noreferrer"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245 240">
										<path
											fill="#FFFFFF"
											d="M104.4 103.9c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1.1-6.1-4.5-11.1-10.2-11.1zM140.9 103.9c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1s-4.5-11.1-10.2-11.1z"
										/>
										<path
											fill="#FFFFFF"
											d="M189.5 20h-134C44.2 20 35 29.2 35 40.6v135.2c0 11.4 9.2 20.6 20.5 20.6h113.4l-5.3-18.5 12.8 11.9 12.1 11.2 21.5 19V40.6c0-11.4-9.2-20.6-20.5-20.6zm-38.6 130.6s-3.6-4.3-6.6-8.1c13.1-3.7 18.1-11.9 18.1-11.9-4.1 2.7-8 4.6-11.5 5.9-5 2.1-9.8 3.5-14.5 4.3-9.6 1.8-18.4 1.3-25.9-.1-5.7-1.1-10.6-2.7-14.7-4.3-2.3-.9-4.8-2-7.3-3.4-.3-.2-.6-.3-.9-.5-.2-.1-.3-.2-.4-.3-1.8-1-2.8-1.7-2.8-1.7s4.8 8 17.5 11.8c-3 3.8-6.7 8.3-6.7 8.3-22.1-.7-30.5-15.2-30.5-15.2 0-32.2 14.4-58.3 14.4-58.3 14.4-10.8 28.1-10.5 28.1-10.5l1 1.2c-18 5.2-26.3 13.1-26.3 13.1s2.2-1.2 5.9-2.9c10.7-4.7 19.2-6 22.7-6.3.6-.1 1.1-.2 1.7-.2 6.1-.8 13-1 20.2-.2 9.5 1.1 19.7 3.9 30.1 9.6 0 0-7.9-7.5-24.9-12.7l1.4-1.6s13.7-.3 28.1 10.5c0 0 14.4 26.1 14.4 58.3 0 0-8.5 14.5-30.6 15.2z"
										/>
									</svg>
								</a>
							</li>
							<li id="telegram" className="icon">
								<a
									title="Check out our Telegram Channel"
									href="https://t.me/joinchat/y_ulJtH0sg0zNWY8"
									target="_blank"
									rel="noopener noreferrer"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.2 69.2" y="0px" x="0px" version="1.1">
										<defs />
										<g>
											<circle r="34.6" cy="34.6" cx="34.6" fill="#fff" />
										</g>
										<g>
											<path
												d="M14.4,34.3c0,0,17.3-7.1,23.3-9.6c2.3-1,10.1-4.2,10.1-4.2s3.6-1.4,3.3,2c-0.1,1.4-0.9,6.3-1.7,11.6               c-1.2,7.5-2.5,15.7-2.5,15.7s-0.2,2.3-1.9,2.7c-1.7,0.4-4.5-1.4-5-1.8c-0.4-0.3-7.5-4.8-10.1-7c-0.7-0.6-1.5-1.8,0.1-3.2               c3.6-3.3,7.9-7.4,10.5-10c1.2-1.2,2.4-4-2.6-0.6c-7.1,4.9-14.1,9.5-14.1,9.5s-1.6,1-4.6,0.1c-3-0.9-6.5-2.1-6.5-2.1               S10.3,35.9,14.4,34.3z"
												fill="hsl(210,14%,75%)"
											/>
										</g>
									</svg>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</Wrapper>
	);
};

const Wrapper = styled.footer`
	background-color: hsl(210, 14%, 75%);
	padding-top: ${rem('40px')};
	padding-right: ${rem('16px')};
	padding-bottom: ${rem('60px')};
	padding-left: ${rem('16px')};
	z-index: 100;
	display: flex;
	flex-shrink: 0;

	@media ${props => props.theme.breakpointLarge} {
		padding-top: ${rem('68px')};
		padding-right: ${rem('48px')} !important;
		padding-bottom: ${rem('56px')};
		padding-left: ${rem('48px')} !important;
	}

	.footer-wrapper {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;

		@media ${props => props.theme.breakpointLarge} {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}
	}

	.branding-and-copyright {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.branding-small  {
		width: ${rem('124px')};
		height: auto;

		@media ${props => props.theme.breakpointLarge} {
			width: ${rem('248px')};
		}

		svg {
			width: 100%;
			height: auto;
		}
	}

	.copyright,
	.powered-by {
		color: ${props => props.theme.white};
		font-size: ${rem('16px')};
		line-height: 1.266666667;
		text-align: center;
		font-weight: 400;
	}
	.powered-by:hover,
	.powered-by:focus {
		color: #1753de;
	}
	#footer-right {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.social-description {
		max-width: 200px;
		color: white;
		text-align: center;
	}
	.social {
		list-style-type: none;
		display: flex;
		flex-direction: row;
		justify-content: center;
		height: ${rem('40px')};
		margin-top: ${rem('28px')};
		margin-left: 0;

		@media ${props => props.theme.breakpointLarge} {
			height: ${rem('48px')};
			justify-content: flex-end;
			margin-top: 0;
		}
	}

	.icon {
		width: ${rem('40px')};
		height: ${rem('40px')};
		margin-left: ${rem('8px')};
		margin-right: ${rem('8px')};
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;

		&:hover {
			svg {
				path {
					fill: ${props => props.theme.primaryColor};
				}
			}
		}
		&#telegram {
			&:hover {
				svg {
					circle {
						fill: ${props => props.theme.primaryColor};
					}
					path {
						fill: hsl(210, 14%, 75%);
					}
				}
			}
		}

		a {
			width: 100%;
			height: 100%;
			display: block;
		}

		@media ${props => props.theme.breakpointLarge} {
			width: ${rem('48px')};
			height: ${rem('48px')};
		}
	}
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/ui/navigation/footer/index.jsx